import { Rule } from "@with-nx/simple-ui/atoms";
import { LatestDigitalDropsStaticData } from "@with-nx/static";
import { Box } from "simple-effing-primitive-layout";
import Image from "next/image";

export const getServerSideProps = async ({ resolvedUrl }) => {
  const latestDigitalDrops = LatestDigitalDropsStaticData.getAll();

  return {
    props: {
      resolvedUrl,
      latestDigitalDrops,
    },
  };
};

export const BackdropsFeatures = ({ mobile }) => {
  const features = [
    {
      title: "Software Included",
      description:
        "Each order comes with our StagePlayer software, the best way to implement digital scenery into your production. Cross-platform compatibility with both Mac and PC.",
      icon: "software",
    },

    {
      title: "Cloud Access",
      description:
        "Download your content immediately and start rehearsing right away. Once installed, access to materials is available offline.",
      icon: "cloud",
    },
    {
      title: "Simple Setup",
      description:
        "Prep your show in StagePlayer with easy-to-use edit features, connect your computer to a projector, then simply present your digital scenery.",
      icon: "setup",
    },
  ];

  return (
    <div className="container">
      <Rule parse={`!_${mobile ? "h1" : "h2"} d:block mb:50 ta:center`}>
        How Digital Backdrops Work
      </Rule>
      <Box
        parse={`d:flex j:space-between ${mobile ? "fd:column" : ""}`}
        style={{
          columnGap: "50px",
          rowGap: mobile ? "20px" : "0",
        }}
      >
        {features.map(({ icon, title, description }) => (
          <Box key={`drop-feat-${icon}`} parse="ta:center">
            <Image
              loading="lazy"
              src={`/assets/digital-backdrops/${icon}.svg`}
              width={80}
              height={90}
            />
            <Rule parse="!_h2 d:block mt:20 mb:20">{title}</Rule>
            <Rule parse="!_bxl c:var(--blue-80) ta:center">{description}</Rule>
          </Box>
        ))}
      </Box>
    </div>
  );
};
